import React, { memo } from 'react';
import { ResizeDropdown } from '@src/features/resizeDropdown/resizeDropdown';
import { AnimationDropdown } from '@src/features/animation/animationSelect';
import createStore from 'polotno/model/store';
import { CloseOutlined } from '@ant-design/icons';

interface FloatingControlsProps {
  store: ReturnType<typeof createStore>;
  visible: boolean;
  onToggleControls: () => void;
}

export const FloatingControls = memo(({ store, visible, onToggleControls }: FloatingControlsProps) => {
  if (!visible) return null;

  return (
    <div style={{ 
      position: 'absolute', 
      top: '0px',
      left: '0px',
      zIndex: 1000,
      background: 'white',
      padding: '16px',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      transition: 'all 0.3s ease',
      alignItems: 'center'
    }}>
      <button
        onClick={onToggleControls}
        style={{
          position: 'absolute',
          top: '2px',
          right: '8px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#666',
          transition: 'all 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#f5f5f5';
          e.currentTarget.style.color = '#333';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'none';
          e.currentTarget.style.color = '#666';
        }}
      >
        <CloseOutlined style={{ fontSize: '16px' }} />
      </button>
      <ResizeDropdown store={store} />
      <AnimationDropdown store={store} />
    </div>
  );
});

FloatingControls.displayName = 'FloatingControls'; 